const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
const PHONE_PATTERN = /^[+\d\s().-]+$/;
const PAN_PATTERN = /^[A-Z]{5}[0-9]{4}[A-Z]$/;

const isBlank = (value) => String(value || "").trim() === "";
const digitCount = (value) => String(value || "").replace(/\D/g, "").length;

export const collectValidationErrors = (checks) => checks.filter(Boolean);

export const showValidationAlert = (errors) => {
  if (!errors.length) return false;
  alert(`Please fix the following validation error(s):\n- ${errors.join("\n- ")}`);
  return true;
};

export const validateRequired = (value, label) => {
  if (!isBlank(value)) return null;
  return `${label} is required.`;
};

export const validateEmail = (value, label = "Email") => {
  if (isBlank(value) || EMAIL_PATTERN.test(String(value).trim())) return null;
  return `${label} is not valid.`;
};

export const validatePhone = (value, label = "Phone") => {
  if (isBlank(value)) return null;

  const text = String(value).trim();
  const digits = digitCount(text);

  if (!PHONE_PATTERN.test(text) || digits < 6 || digits > 18) {
    return `${label} must contain 6 to 18 digits and may include +, spaces, hyphen, or brackets.`;
  }

  return null;
};

export const validateMobile = (value, label = "Mobile") => {
  if (isBlank(value)) return null;

  const text = String(value).trim();
  const digits = digitCount(text);

  if (!PHONE_PATTERN.test(text) || digits < 10 || digits > 15) {
    return `${label} must contain 10 to 15 digits and may include country code.`;
  }

  return null;
};

export const validateWebsite = (value, label = "Website") => {
  if (isBlank(value)) return null;

  const text = String(value).trim();
  const normalized = /^https?:\/\//i.test(text) ? text : `https://${text}`;

  try {
    const url = new URL(normalized);
    if (url.hostname.includes(".")) return null;
  } catch (err) {
    // Fall through to the common error message.
  }

  return `${label} is not valid.`;
};

export const validatePAN = (value, label = "PAN No") => {
  if (isBlank(value) || PAN_PATTERN.test(String(value).trim().toUpperCase())) return null;
  return `${label} must be in valid PAN format, for example ABCDE1234F.`;
};
